import { Menu, MenuButton, MenuItem, MenuList, Portal } from '@chakra-ui/react';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import {
  AlignBottom,
  AlignCenterHorizontal,
  AlignCenterVertical,
  AlignLeft,
  AlignRight,
  AlignTop,
  ArrowUpIcon,
  DeleteIcon,
  EyeIcon,
} from '@sketchnote/icons';
import * as React from 'react';
import {
  AlignType,
  ColorStyle,
  fills,
  TDShapeType,
  TDSnapshot,
  TDToolType,
  useTldrawApp,
} from 'sn-wb-tldraw';

import { CircleIcon } from '../Primitives/icons';
import { colors, strokes } from './ColorMenu';
import { ColorSelector } from './ColorSelector';
import { EditorTools } from './EditorTools';
import { editorIcons } from './EditorTools';
import { stickyColors } from './NoteMenu';
import { SizeSelector, strokeSize } from './SizeSelector';

export const Alignment = React.memo(function Alignment(): JSX.Element {
  const app = useTldrawApp();

  const selectedId = app.useStore((s) => s.document.pageStates.page.selectedIds);

  const alignLeft = React.useCallback(() => {
    app.align(AlignType.Left);
  }, [app]);

  const alignCenterHorizontal = React.useCallback(() => {
    app.align(AlignType.CenterHorizontal);
  }, [app]);

  const alignRIght = React.useCallback(() => {
    app.align(AlignType.Right);
  }, [app]);

  const alignTop = React.useCallback(() => {
    app.align(AlignType.Top);
  }, [app]);

  const alignBottom = React.useCallback(() => {
    app.align(AlignType.Bottom);
  }, [app]);

  const alignCenterVertical = React.useCallback(() => {
    app.align(AlignType.Bottom);
  }, [app]);

  return (
    <>
      <div className="transform scale-120">
        <DropdownMenu.Root dir="ltr">
          <DropdownMenu.Trigger asChild>
            <div className="flex p-2 items-center justify-center gap-2 cursor-pointer">
              <AlignLeft />
              <ArrowUpIcon />
            </div>
          </DropdownMenu.Trigger>
          <DropdownMenu.Content
            className="flex flex-row items-center gap-8 py-2 justify-center bg-primary-900 rounded-sm cursor-pointer  "
            style={{ padding: '4px 8px', transform: 'translate(1px,-56px)' }}
          >
            <DropdownMenu.Item>
              <div className="transform scale-120 p-2" onClick={alignLeft}>
                <AlignLeft />
              </div>
            </DropdownMenu.Item>
            <DropdownMenu.Item>
              <div className="transform scale-120 p-2" onClick={alignCenterHorizontal}>
                <AlignCenterHorizontal />
              </div>
            </DropdownMenu.Item>
            <DropdownMenu.Item>
              <div className="transform scale-120 p-2" onClick={alignRIght}>
                <AlignRight />
              </div>
            </DropdownMenu.Item>
            <DropdownMenu.Item>
              <div className="transform scale-120 p-2" onClick={alignTop}>
                <AlignTop />
              </div>
            </DropdownMenu.Item>
            <DropdownMenu.Item>
              <div className="transform scale-120 p-2" onClick={alignCenterVertical}>
                <AlignCenterVertical />
              </div>
            </DropdownMenu.Item>
            <DropdownMenu.Item>
              <div className="transform scale-120 p-2" onClick={alignBottom}>
                <AlignBottom />
              </div>
            </DropdownMenu.Item>
          </DropdownMenu.Content>
        </DropdownMenu.Root>
      </div>
    </>
  );
});
